var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSharedBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.17 9.43A1.6 1.6 0 0 1 3.04 6.7l1.453-1.456a1.593 1.593 0 0 1 1.131-.468 1.6 1.6 0 0 1 1.132.468.457.457 0 0 1 .132.352.457.457 0 0 1-.132.29.469.469 0 0 1-.643 0 .686.686 0 0 0-.969 0L3.685 7.346a.686.686 0 0 0 .97.97l.863-.864a.114.114 0 0 1 .125-.025c.232.094.48.143.731.142h.046a.114.114 0 0 1 .08.195l-1.2 1.2a1.59 1.59 0 0 1-1.13.466Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38 7.225H6.295a1.592 1.592 0 0 1-.309-.045l-.067-.018a.904.904 0 0 1-.073-.024c-.024-.01-.05-.017-.074-.027L5.7 7.08a1.586 1.586 0 0 1-.458-.32.457.457 0 0 1 0-.645.469.469 0 0 1 .643 0 .686.686 0 0 0 .969 0l.375-.372.009-.01L8.31 4.661a.686.686 0 0 0-.97-.97l-.861.859a.114.114 0 0 1-.125.025 1.92 1.92 0 0 0-.73-.143h-.042a.114.114 0 0 1-.084-.195l1.2-1.198A1.6 1.6 0 0 1 8.96 5.303L7.505 6.757a1.6 1.6 0 0 1-.742.421h-.012l-.066.014-.037.007-.079.011H6.53c-.03 0-.056.006-.08.007l-.07.008Z",
  fill: "#fff"
})));
export { SvgSharedBadge as ReactComponent };
export default __webpack_public_path__ + "b6a8abb9fe848b76f834787eeeb28ac2.svg";